import axios from 'axios'

const { CancelToken } = axios
const source = CancelToken.source()
const http = axios.create({
  baseURL: '',
  headers: {}
})

const finallArr = (url)=>{
  let  urlArr = url.split('/')
  console.log('urlArr',urlArr)
  if(urlArr[urlArr.length-2]=='rdt'){
    return true
  }else{
    return false
  }
}

let pending = []
let cancelPending = (config) => {
  console.log('deletepending', pending)
  for (let i = pending.length - 1; i >= 0; i--) {
    if (config) {
      if (pending[i].u === config.url) {
        console.log('delete request12')
        pending[i].f() // 取消请求
        pending.splice(i, 1) // 移除当前请求记录
      }
    } else {
      pending[i].f() // 取消请求
      pending.splice(i, 1) // 移除当前请求记录
    }
  }
}

// 是否携带cookie
http.defaults.withCredentials = false
// if (sessionStorage.getItem('token')) {
//   http.defaults.headers.common.token = sessionStorage.token
// }

http.interceptors.request.use(
  (config) => {
    cancelPending(config)
    config.cancelToken = new CancelToken((c) => {
      pending.push({'u': config.url, 'f': c})
    })
    let token
    if (finallArr(config.url)) {
      token = localStorage.getItem('token')
    }
    if (token) {
      config.headers.Authorization = 'bearer'+ token
    }
    // console.log('config',config)
    // console.log('bear', token,http.defaults.headers.Authorization)
    return config
  },
  (error) => Promise.reject(error)
)
// 添加响应拦截器
http.interceptors.response.use(
  async (response) => {
    // 对响应数据做点什么
    cancelPending(response.config)
    // response.config.cancelToken = source.token
    console.log('response',response)
    return response.data
  },
  (error) => Promise.reject(error)
)

export default http



// WEBPACK FOOTER //
// ./src/axios/fetch.js